<template>
  <main>
    <HeroSection />
    <MaterialGrid />
  </main>
</template>

<script setup lang="ts">
import HeroSection from '../components/HeroSection.vue'
import MaterialGrid from '../components/MaterialGrid.vue'
</script>
